export const isVibefamGeneratedEmail = (email) => {
    return email.endsWith('@sub-account.vibefam.com')
}
